<div #drawer id="nav-drawer" class="offcanvas position-absolute bg--primary shadow-small" tabindex="-1" [class]="{
    'offcanvas-start': !this.uiService.isMobile(),
    'offcanvas-top': this.uiService.isMobile(),
}">

    @if(selectedIndex() != undefined){
        
        <div class="d-flex flex-column h-100 w-100">

            <div class="module-header border-bottom">
                    
                <div class="p-3 position-relative d-flex flex-column">

                    <div class="module-header-bg position-absolute top-0 bottom-0 start-0 end-0 overflow-hidden">
                        <div class="module-header-icon">
                            <fa-icon [icon]="['fas', selectedModule()?.icon ?? 'box']"/>
                        </div>
                    </div>

                    <span class="m-0 p-0 font-size-15rm font-semibold font-tertiary mb-3">{{selectedModule()?.name}}</span>

                    <div class="d-flex flex-column gap-3">
                        @if (selectedModule()?.name == Modules.Profile){
                            <div class="position-absolute top-0 right-0 p-3">
                                <app-theme-mode-button/>
                            </div>
                            <div class="col-12 d-flex flex-row align-items-center gap-3">

                                <div class="user-image">
                                    <app-user-image [user]="'session'" [size]="'medium'"/>
                                </div>

                                <div class="flex-grow-1 d-flex flex-column overflow-hidden">
                                    <span class="font-size-12rm font-medium">{{userService.user()?.displayName}}</span>

                                    <div class="d-flex flex-row gap-1 align-items-center">
                                        <fa-icon class="font-size-08rm color--text-primary-30" [icon]="['fas', 'user']" style="line-height: 0rem;"/>
                                        <span class="font-size-08rm font-light text-single-line flex-grow-1">{{userService.user()?.user?.userName}}</span>
                                    </div>

                                    <div class="d-flex flex-row gap-1 align-items-center">
                                        <fa-icon class="font-size-08rm color--text-primary-30" [icon]="['fas', 'envelope']" style="line-height: 0rem;"/>
                                        <span class="font-size-08rm font-light text-single-line flex-grow-1">{{userService.user()?.user?.email ?? '-'}}</span>
                                    </div>
                                </div>

                            </div>
                        }
                        
                        @if(selectedModule()?.name == Modules.Search || selectedModule()?.children?.length && selectedModule()?.children!.length > 0){
                            <app-form-control #searchControl [(control)]="search" [type]="'text'" [validation]="false"/>
                        }
                    </div>

                </div>

            </div>

            <div class="position-relative flex-grow-1">
                <div class="position-absolute top-0 bottom-0 left-0 right-0">
                    <div class="d-flex flex-column gap-1 overflow-y-auto w-100 h-100">
                        @if(selectedModule()?.name == Modules.Search && searchQuery()
                        || selectedModule()?.name != Modules.Search){
                            @for(module of filteredData(); track $index){

                                @let moduleNavigationFlag = featureFlagsService.getNavigationFlag(module.id);

                                @if(
                                    (selectedModule()?.name == Modules.Search || selectedModule()?.name == module.name)
                                    && (moduleNavigationFlag == undefined || moduleNavigationFlag.enabled)
                                    && module?.name != Modules.Search
                                ){
                                    <div class="nav-module">
                                        @if(selectedModule()?.name == Modules.Search){
                                            <div class="nav-module-listing" (click)="openNavigationModule(module)" [class]="{
                                                'nav-module-listing-disabled': module.visibility == navigationVisibility.SearchOnly || module.visibility == navigationVisibility.Hidden
                                            }">
                                                <span class="font-semibold">{{module.name}}</span>
                                                <div class="nav-module-listing-icon">
                                                    <fa-icon [icon]="['fas', module.icon ?? 'box']"/>
                                                </div>
                                            </div>
                                        }
                                        
                                        <div class="nav-listing-container gap-3" [class]="{'pt-2':selectedModule()?.name != Modules.Search}">
                                            @let moduleGroup = getModuleGrouped(module);

                                            @for (group of moduleGroup; track $index) {

                                                <div class="d-flex flex-column">
                                                    @if(selectedModule()?.name != Modules.Search){
                                                        <app-collapse-header [title]="group.name" [state]="'expanded'">
                                                            <span class="d-flex flex-column" ngProjectAs="content">
                                                                @for (child of group.children; track $index){
                                                                    @let childNavigationFlag = featureFlagsService.getNavigationFlag(child.id);

                                                                    @if(
                                                                        (childNavigationFlag == undefined || childNavigationFlag.enabled)
                                                                        && child.visibility != navigationVisibility.Hidden
                                                                    ){
                                                                        <app-navigation-listing appCounter [navigation]="child" [isCompany]="module.company ?? false"/>
                                                                    }
                                                                }
                                                            </span>
                                                        </app-collapse-header>
                                                    }
                                                    @else {
                                                        @for (child of group.children; track $index){
                                                            @let childNavigationFlag = featureFlagsService.getNavigationFlag(child.id);

                                                            @if(
                                                                (childNavigationFlag == undefined || childNavigationFlag.enabled)
                                                                && child.visibility != navigationVisibility.Hidden
                                                            ){
                                                                <app-navigation-listing [navigation]="child" [isCompany]="module.company ?? false"/>
                                                            }
                                                        }
                                                    }
                                                </div>
                                            }

                                        </div>
                                    </div>
                                }
                            }
                            @empty {
                                <div class="p-2 font-light fst-italic font-size-09rm text-center">
                                    <span>No results</span>
                                </div>
                            }
                        }
                        @else if(selectedModule()?.name == Modules.Search){
                            <div class="p-2 font-light fst-italic font-size-09rm text-center">
                                <span>Begin your search by typing in the search box...</span>
                            </div>
                        }
                        
                    </div>
                </div>
            </div>

        </div>

    }
</div>